import { z } from 'zod/v4';

export const ReceiverDTO = z.object({
  id: z.string(),
  name: z.string(),
  mute_time_interval_names: z.array(z.string()),
  active_time_interval_names: z.array(z.string()),
  receiver_senders: z.array(
    z.object({
      sender_name: z.string(),
      active: z.boolean(),
      address: z.string(),
      extend_data: z.looseObject({}),
      send_resolve: z.boolean(),
      sender_active: z.boolean(),
    }),
  ),
});

export const ReceiverItemDTO = ReceiverDTO.pick({
  id: true,
  name: true,
});

export type Receiver = z.infer<typeof ReceiverDTO>;
export type ReceiverItem = z.infer<typeof ReceiverItemDTO>;